import React, { useEffect, useState } from "react";
import view from "../assets/View.svg";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";
import "./css/Users.css";
import TopBar from "../Components/TopBar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import instance from "../utils/api";
import Loading from "../assets/Loading.svg";

const CallLogs = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [filteredData1, setFilteredData1] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [open, setOpen] = useState(false); // Modal state
  const rowsPerPage = 10;
  const startindex = (page - 1) * rowsPerPage;

  const handleUsers = async () => {
    try {
      const response = await instance.get("api/Admin/getCallLogs");
      console.log(response.data.data);
      setData(response.data.data);
      // setFilteredData(filter);
    } catch (error) {
      console.log(error);
      toast.error(error.data.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleUsers();
  }, []);

  console.log(data);
  // console.log(filteredData);

  const dataToShow = data?.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  // const dataToShow1 = filteredData1?.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  // const handleClickOpen = () => {
  //     setOpen(true);
  // };

  // const handleClose = () => {
  //     setOpen(false);
  // };
  return (
    <div>
      <TopBar title={"Call Logs"} />
      {loading ? (
        <div className="loading-spinner">
          <img src={Loading} alt="loading" height={80} width={80} />
        </div>
      ) : (
        <div className="_2wae">
          <div className="forget-hark">
            {/* <SearchBar data={data} setFilteredData={setFilteredData} filterKey={'name'} /> */}
            <div></div>
            <div className="_1fry" style={{ display: "flex" }}>
              <Pagination
                page={page}
                setPage={setPage}
                count={data.length}
                rowsPerPage={rowsPerPage}
              />

              {/* <TableFilter data={data} setFilteredData={setFilteredData} filterKey={'student_id.first_name'} /> */}
            </div>
          </div>
          <div className="studentportal">
            <table className="table">
              <thead>
                <tr>
                  <th id="as-1">S.No</th>
                  <th id="as-1">User Name</th>
                  <th id="ps">User Mobile No</th>
                  <th id="ps">Service Provider Name</th>
                  <th id="hs-1">Service Provider Number</th>
                  <th id="hs-1">Log Date</th>
                </tr>
              </thead>
              <tbody>
                {dataToShow.map((data, item) => (
                  <tr key={item}>
                    <td className="cuatros-pegs">{startindex + item + 1}</td>
                    <td className="cuatros-pegs">{data.user_details.name}</td>
                    <td className="prawners-bind-1">{data.user_details.mobile_no}</td>
                    <td className="prawners-bind-1">{data.Service_provider_details.name}</td>
                    <td className="prawners-bind-1">{data.Service_provider_details.mobile_no}</td>
                    <td className="prawners-bind-1">{new Date(data.createdAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallLogs;
